<div
  class="page-body"
  *ngIf="
    market === Market.SE &&
    availablePaymentMethods &&
    paymentRequest &&
    !loading
  "
>
  <div class="contents-wrapper">
    <div class="contents-container">

      <!-- Single CREDIT method: show preliminary installment plans -->
      <app-preliminary-installments
        *ngIf="showPreliminaryInstallments; else paymentMethodList"
        [installmentPlans]="preliminaryInstallmentPlans"
        [primaryColor]="primaryColor"
      ></app-preliminary-installments>

      <!-- Multiple methods: show standard selection list -->
      <ng-template #paymentMethodList>
        <app-expandable-list-item
          *ngFor="let context of paymentMethodContexts; let i = index"
          [title]="context.title"
          [description]="context.subTitle"
          [imgSrc]="context.imgSrc"
          [zaverIcon]="context.zaverIcon"
          [bulletPoints]="context.bulletPoints"
          [selected]="availablePaymentMethods[i] === selectedPaymentMethod"
          [isFirstItem]="i === 0"
          [isLastItem]="i === availablePaymentMethods.length - 1"
          [showTermsLink]="shouldShowTermsLink(availablePaymentMethods[i])"
          (onTermsClick)="setModalInfo('terms')"
          [color]="primaryColor"
          (click)="handlePaymentMethodSelection(i)"
        ></app-expandable-list-item>
      </ng-template>

      <div class="bottom-section-wrapper">
        <app-payment-request-info
          *ngIf="!paymentRequest.amountDenotesCreditLimit"
          [lineItems]="paymentRequest.lineItems"
          [market]="paymentRequest.market"
          [value]="paymentRequest.value"
          [buttonText]="ctaLabel"
          [isButtonDisabled]="navigationInProgress"
          (onContinueClick)="handleContinueClick()"
          (onDetailsClick)="setModalInfo()"
        ></app-payment-request-info>

        <div
          class="credit-limit-info"
          *ngIf="paymentRequest.amountDenotesCreditLimit"
        >
          <label>{{ paymentRequest.title }}</label>
          <label
            >Kreditutrymme prövas på
            {{
              paymentRequest.amount.toLocaleString('sv', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}
            SEK för att ge dig en marginal ifall du önskar göra ändringar på
            installationen i efterhand.
          </label>
        </div>

        <div class="footer-wrapper">
          <div class="footer-container">
            <app-se-terms
              *ngIf="market === Market.SE"
              [paymentRequest]="paymentRequest"
            ></app-se-terms>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="market === Market.SE && modalActive"
  buttonText="Stäng"
  title="Visa detaljer"
  (onClose)="deactivateModal()"
>
  <app-selector
    *ngIf="selectorItems"
    #selector
    [selectorItems]="selectorItems"
    [selectedItem]="selectedItem"
  ></app-selector>
</zaver-checkout-modal>
